<template>
    <Poptip :title="title" trigger="click" popper-class="cPop-box" :transfer="true">
        <div slot="content">
            <div class="input-box">
                <span class="text-icon">$</span>
                <Input v-model="value" style="width: 2rem;" @on-keyup="onInputNumber" @on-change="onInputNumber" :maxlength="14"/>
            </div>
            <div class="footer-wrapper">
                <Button type="primary" @click="onConfirm">确定</Button>
                <Button @click="onCancel">取消</Button>
            </div>
        </div>
        <slot></slot>

    </Poptip>
</template>

<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
export default {
    name: 'pop-box',
    mixins: [mixins],
    props: {
        title: {
            default: '每日预算',
            type: String,
        },
    },
    data() {
        return {
            value: '',
        };
    },
    methods: {
        onCancel() {
            this.$root.$el.click();
            this.value = '';
        },
        onConfirm() {
            this.$root.$el.click();
            this.$emit('change', this.value);
            this.value = '';
        },
        /*
         * @description 限制只能输入数字
         * @param event:obj 事件对象
         */
        onInputNumber(event) {
            this.mixinRegNum(event, 5, 0, 99999999.99999);
        },
    },
};
</script>

<style lang="scss">
.cPop-box {
    .ivu-poptip-title {
        text-align: left;
    }
    .ivu-poptip-title:after {
        height: 0;
    }
    .input-box {
        position: relative;
        .text-icon {
            position: absolute;
            top: 0.08rem;
            left: 0.08rem;
            z-index: 2;
        }
        .ivu-input {
            padding-left: 0.2rem;
        }
    }
    .footer-wrapper {
        text-align: right;
        padding: 0.1rem 0 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cPopBox.vue